// Single source of truth for the "auto-pick station/tonnage" rule used by the Process
// Cost table (NpdForm) AND shown in the Operations master, so both agree and the system
// never disagrees with itself.
//  • Ultrasonic Cleaning / Deburring + Cleaning → Ultrasonic
//  • Deburring                                  → Deburring
//  • Inspection / Visual / Gauge                → Manpower (a manual / man-power station)
// Returns "" when no rule matches (a press step — the engineer picks the tonnage).
export function autoTonnageForProcess(name) {
  const s = (name || "").toLowerCase();
  if (/ultrasonic/.test(s)) return "Ultrasonic";
  const isDeburr = /de\s*-?\s*burr/.test(s);
  if (isDeburr && /clean/.test(s)) return "Ultrasonic";
  if (isDeburr) return "Deburring";
  // "Thread inspection" is covered by "inspection"; bare "thread" is excluded
  // (thread-rolling/tapping are machine ops, not a manual station).
  if (/inspection|visual|\bgau?ge\b/.test(s)) return "Manpower";
  return "";
}

// Non-press stations that the rule can assign (also always offered in the tonnage dropdown).
// "Manpower" = a man-power / manual station (no press). "Manual" is treated as its alias
// so any parts saved before the rename still resolve to the same station.
export const STATION_TONNAGES = ["Manpower", "Deburring", "Ultrasonic"];

// Display label for the "Auto Tonnage" columns/badges (masters + operation popup).
// Unlike autoTonnageForProcess (which drives the costing auto-pick and returns "" for
// non-station steps), this also labels no-machine steps like Shearing so nothing shows a
// bare blank. Returns { label, kind: "station" | "no-machine" | "press" }.
export function stationLabel(name, noMachine) {
  const auto = autoTonnageForProcess(name);
  if (auto) return { label: auto, kind: "station" };
  if (noMachine || /shearing|slitting/i.test(name || "")) return { label: "No machine", kind: "no-machine" };
  return { label: "—", kind: "press" };
}

// Effective station for an operation: an explicit "default_tonnage" set on the operation
// master wins over the name-based rule, so admins can pin any operation to a station.
export function opStation(op) {
  const explicit = (op?.default_tonnage || "").trim();
  if (explicit) return { label: explicit, kind: "station", explicit: true };
  return { ...stationLabel(op?.name, op?.no_machine), explicit: false };
}
